var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "container"
  }, [_c("div", {
    staticClass: "left-container"
  }, [_c("a-select", {
    attrs: {
      "option-filter-prop": "label",
      placeholder: "select a language"
    },
    model: {
      value: _vm.leftLanguage2,
      callback: function ($$v) {
        _vm.leftLanguage2 = $$v;
      },
      expression: "leftLanguage2"
    }
  }, _vm._l(_vm.fromLanguages, function (lan) {
    return _c("a-select-option", {
      key: lan.value,
      attrs: {
        label: lan.label,
        value: lan.value
      },
      nativeOn: {
        click: function ($event) {
          return _vm.chooseLan(lan.value);
        }
      }
    }, [_vm._v(_vm._s(lan.label) + " ")]);
  }), 1), _c("img", {
    staticClass: "switch",
    attrs: {
      src: _vm.switchImg,
      alt: ""
    },
    on: {
      click: _vm.exchange
    }
  }), _c("a-select", {
    attrs: {
      "option-filter-prop": "label",
      placeholder: "select a language"
    },
    model: {
      value: _vm.rightLanguage,
      callback: function ($$v) {
        _vm.rightLanguage = $$v;
      },
      expression: "rightLanguage"
    }
  }, _vm._l(_vm.toLanguages, function (lan) {
    return _c("a-select-option", {
      key: lan.value,
      attrs: {
        label: lan.label,
        value: lan.value
      },
      nativeOn: {
        click: function ($event) {
          return _vm.chooseRightLan();
        }
      }
    }, [_vm._v(_vm._s(lan.label) + " ")]);
  }), 1), _c("div", {
    staticStyle: {
      "padding-top": "20px"
    }
  }, [_c("a-textarea", {
    attrs: {
      placeholder: "请输入需要翻译的内容",
      "show-count": "",
      "auto-size": {
        minRows: 13,
        maxRows: 13
      },
      allowClear: ""
    },
    on: {
      input: _vm.inputChange
    },
    nativeOn: {
      keydown: function ($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.onKeyEnter.apply(null, arguments);
      }
    },
    model: {
      value: _vm.translateOrigin,
      callback: function ($$v) {
        _vm.translateOrigin = $$v;
      },
      expression: "translateOrigin"
    }
  })], 1), _vm.translateOrigin ? _c("p", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showMessage,
      expression: "showMessage"
    }],
    staticStyle: {
      "padding-top": "12px"
    }
  }, [_vm._v("您输入的语言可能是："), _c("span", {
    staticClass: "changeLan",
    on: {
      click: function ($event) {
        return _vm.changeLeftLan(_vm.identifyLanguage);
      }
    }
  }, [_vm._v(_vm._s(_vm.LANGUAGE_ENGLISH_MAP.get(_vm.identifyLanguage)))])]) : _vm._e()], 1), _c("div", {
    staticClass: "right-container"
  }, [_c("div", {
    staticClass: "up"
  }, [_c("div", {
    staticClass: "bold"
  }, [_vm._v("翻译领域")]), _c("a-select", {
    attrs: {
      "option-filter-prop": "label",
      allowClear: "",
      placeholder: "select a domain"
    },
    model: {
      value: _vm.tranDomain,
      callback: function ($$v) {
        _vm.tranDomain = $$v;
      },
      expression: "tranDomain"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: "default"
    }
  }, [_vm._v("通用领域")]), _c("a-select-option", {
    attrs: {
      value: "Patent Domain",
      disabled: _vm.patentDisabled
    }
  }, [_vm._v("专利领域")]), _c("a-select-option", {
    attrs: {
      value: "Announcement Domain",
      disabled: _vm.announcementDisabled
    }
  }, [_vm._v("公告领域")])], 1)], 1), _c("div", {
    staticClass: "result-area"
  }, [_vm._l(_vm.translateResult, function (item) {
    return [item !== "" ? _c("div", {
      key: item,
      style: _vm.rightTextAreaStyle,
      domProps: {
        textContent: _vm._s(item)
      }
    }) : _c("br", {
      key: item + "br"
    })];
  })], 2), _c("div", {
    class: ["button", {
      "button-disabled": _vm.translateOrigin.trim() === "" || _vm.isTranslating
    }],
    on: {
      click: _vm.startTranslation
    }
  }, [_vm._v(" " + _vm._s(_vm.isTranslating ? "翻译中" : "开始翻译") + " ")])])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };